module.exports = __webpack_public_path__ + "static/media/Vector(4).2e413b62.svg";